module.exports = __webpack_public_path__ + "static/media/46.973cb6f8.gif";